import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import CateringSection from '../Components/Catering/Catering'; 
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function CateringPage() {
    return (
        <>
            <Helmet>
                <title>Vegetarian Event Catering in Coimbatore | Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, specializing in gourmet event catering for birthdays, corporate events, and parties in R.S. Puram." />
                <meta name="keywords" content="Event catering Coimbatore, Homemade vegetarian catering, Party food Coimbatore, Corporate catering Coimbatore, Birthday catering Coimbatore, Veg snacks delivery" />
                <link rel="canonical" href="https://ticklingtummy.com/catering" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Vegetarian Event Catering in Coimbatore | Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, specializing in gourmet event catering for birthdays, corporate events, and parties in R.S. Puram." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/catering-service-main-image.png" />
                <meta property="og:url" content="https://ticklingtummy.com/catering" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Vegetarian Event Catering in Coimbatore | Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, specializing in gourmet event catering for birthdays, corporate events, and parties in R.S. Puram." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/catering-service-main-image.png" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://ticklingtummy.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Catering",
                "item": "https://ticklingtummy.com/catering"
              }
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Vegetarian Event Catering",
            "description": "Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, specializing in gourmet event catering for birthdays, corporate events, and parties in R.S. Puram.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Tickling Tummy",
              "image": "https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg"
            },
            "areaServed": {
              "@type": "City",
              "name": "Coimbatore"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Catering Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Birthday Party Catering"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Corporate Event Catering"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Small House Party Catering"
                  }
                }
              ]
            }
          }
        ], null, 2)}
        </script>

            <HeaderOne />
            <CateringSection />
            <Footer />
        </>
    );
}

export default CateringPage;
